export let IntegrationsActionTypes;

(function (IntegrationsActionTypes) {
  IntegrationsActionTypes["ValidateOAuthPermissions"] = "[Integrations] Validate OAuth Permissions";
  IntegrationsActionTypes["UpdateWordpressAuthorizationResponseAction"] = "[Integrations] Update Wordpress Authorization Response";
  IntegrationsActionTypes["SetWordpressPermissions"] = "[Integrations] Set Wordpress Permissions";
  IntegrationsActionTypes["WordPressRedirect"] = "[Integrations] WordPress Auth Redirect";
})(IntegrationsActionTypes || (IntegrationsActionTypes = {}));